import React from "react";
import FiberImage
  from "../../common/results/views/fiber/types/components/fiberimage";
import Grid from "material-ui/Grid/index";
import {withStyles} from "material-ui/styles/index";
import styles from "./BatteryStatementStyles";

class BatteryStatementFr extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {classes} = this.props;

    return <div className={classes.batteryAgreement}>
      <p className={classes.warning}>
        Informations importantes concernant les produits contenant des batteries
        lithium/lithium-ion
        Il est interdit d'expédier des batteries endommagées / défectueuses
      </p>
      <p>
        <b>Vérifiez votre batterie!</b> Retirez la batterie avant l'expédition
        si vous savez que votre batterie est tombée,
        endommagée ou perforée. Ou si vous constatez un ou plusieurs signes
        suivants:
      </p>
      <ul>
        <li>Bombée</li>
        <li>Changement de couleur</li>
        <li>Fuite</li>
        <li>Odeur inhabituelle</li>
        <li>Surchauffe</li>
        <li>Performances erratiques de l'appareil</li>
      </ul>
      <p>
        Assurez-vous que les batteries endommagées sont éliminées conformément à
        vos réglementations locales.</p>
      <p>En tant que personne expédiant ce produit pour quelque raison que ce
        soit, y compris, mais sans s'y limiter, le retour
        pour réparation, entretien ou étalonnage, vous êtes responsable de vous
        assurer que cela est fait en toute sécurité et
        légalement. Si vous renvoyez votre appareil avec les piles installées,
        veuillez cocher pour confirmer que vous avez lu
        ce qui précède et emballer comme il se doit.
      </p>
      <p><b>Emballage pour expédition aérienne:</b></p>
      <ul>
        <li>
          TLa batterie de votre appareil a été testée selon la spécification
          UN38.3.
          C'est &lt; 20Wh par cellule / 100Wh par batterie
          Le poids de la batterie peut être compris entre 200 et 800g selon le
          produit
          Lorsqu’elle est contenue dans un appareil, il s’agit :
          <ul>
            <li>UN3481</li>
            <li>désignation officielle de transport - Batteries lithium-ion
              contenues dans l'appareil
            </li>
            <li>Vous devez expédier conformément à l'instruction d'emballage
              IATA DGR 967 section II.
            </li>
          </ul>
        </li>
        <li>Laissez la batterie dans votre appareil
        </li>
        <li>Assurez-vous que l'appareil est éteint et ne peut pas être activé
          accidentellement.
        </li>
        <li>Pour le transport, votre appareil ne doit pas dépasser une charge
          d'état supérieure à 30% de la capacité
          nominale.<br/>
          ou<br/>
          À partir du 1er janvier 2026, votre appareil ne doit pas dépasser une
          charge d'état supérieure à 30% de sa
          capacité nominale ou avec une capacité de batterie indiquée ne
          dépassant pas 25%
        </li>
        <li>Ne dépassez pas plus de 5kg de poids de batterie par colis</li>
        <li>Assurez-vous que votre appareil est dans un emballage extérieur
          rigide et solide, capable de résister à une
          chute de 1,2m sans dommage
        </li>
        <li>Le recto de votre colis ne doit pas être marqué et les éléments
          ci-dessous doivent tous être sur un côté de
          votre colis solidement fixés et raisonnablement protégés contre les
          dommages/conditions externes:
          <ul>
            <li>Nom et adresse de l'expéditeur</li>
            <li>Nom et adresse du destinataire</li>
            <li>Étiquette de batterie UN3481 (taille de l'étiquette 100mm x
              10mm/le texte UN3481 doit être d'au moins
              12mm)
            </li>
          </ul>
        </li>
        <li>Assurez-vous que l'appareil dans l'emballage est sécurisé et ne
          bouge pas
        </li>
        <li>Vous devez vous assurer que le transporteur marque les AWB «
          Batteries lithium-ion conformément à la
          section II du PI 967 (si le transporteur est réservé par TREND
          Networks, c'est la responsabilité de
          TREND Networks)
        </li>
      </ul>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} align="center">
        <FiberImage
          alt=""
          src={'/images/battery-agreement.png'}
        />
      </Grid>
      <p>Appareils contenant des batteries lithium-ion:</p>
      <p>SignalTEK QT, 10G CT/NT/FT/PRO, LanTEK II/III/IV/S/L, SecuriTEST IP,
        FiberMASTER QUAD/Multi mode/Single mode/Pon OTDR, FiberMASTER Fusion
        Splicer S40 & S60</p>
      <p className={classes.warning}>
        Veuillez-vous assurer qu'aucun article interdit n'est inclus dans
        l'envoi de votre appareil à TREND
        Networks. Cela comprend, sans toutefois s'y limiter : l'alcool, les
        objets tranchants (ciseaux, hachoirs,
        etc.), les aérosols, les produits corrosifs, les liquides inflammables,
        etc.
      </p>
    </div>;
  }
}

export default withStyles(styles)(BatteryStatementFr);
